export const EPaycardOnboardingStatus = {
  DECLINED: "declined",
  PROVISIONED: "provisioned",
  REQUESTED: "requested",
} as const;

export type TPaycardOnboardingStatus =
  (typeof EPaycardOnboardingStatus)[keyof typeof EPaycardOnboardingStatus];
